const B_1 = [
    {
        title: '项目管理',
        path: '/bidding/project/zfcg/list'
    }
]

export default {
    path: 'zfcg',
    component: () => import(/*webpackChunkName: 'projectZfcg'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import(/*webpackChunkName: 'projectZfcg'*/'@views/bidding/views/project/zfcg/list'),
            meta: {
                title: '项目列表',
                topNav: true,
                bread: B_1
            },
        },{
            path:"detail",
            component: () => import(/*webpackChunkName: 'projectZfcg'*/'@views/bidding/views/project/zfcg/detail'),
            meta: {
                title: '项目详情',
                bread: B_1
            },
        },{
            path:"form",
            component: () => import(/*webpackChunkName: 'projectZfcg'*/'@views/bidding/views/project/zfcg/form'),
            meta: {
                title: '添加项目',
                bread: B_1
            },
        },
    ]
}
